export const OkrsConstants = {
    ADD_OKR_SUCCESS: "ADD_OKR_SUCCESS",
    ADD_OKR_FAILURE: "ADD_OKR_FAILURE",

    DELETE_OKR_SUCCESS: 'DELETE_OKR_SUCCESS',
    DELTET_OKR_FAILURE: 'DELETE_OKR_FAILURE'
}